export const ANONYMITY_THRESHOLD = 6;

export enum dashboardFilterContext {
  'activity' = 'ACTIVE_USERS',
  'wellbeing' = 'WELLBEING_DATA',
  'managerReporting' = 'MANAGER_REPORTING',
  'manageUsers' = '', //noop as filters don't get used here
  'summarySupersetDashboard' = 'SUMMARY_SUPERSET_DASHBOARD',
  'platformSupersetDashboard' = 'PLATFORM_SUPERSET_DASHBOARD',
  'novaSupersetDashboard' = 'NOVA_SUPERSET_DASHBOARD',
  'therapyAndCoachingSupersetDashboard' = 'THERAPY_AND_COACHING_SUPERSET_DASHBOARD',
}

export enum timeFilterBreakdownPeriod {
  'LAST_30_DAYS' = 'DAY',
  'LAST_12_WEEKS' = 'WEEK',
  'LAST_6_MONTHS' = 'MONTH',
  'ALL_TIME' = 'MONTH',
}
